var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { lowerCase, startCase } from 'lodash';
// import rpc from 'src/api/rpc'
import Vue from 'vue';
import rpc from 'src/api/rpc';
import Card from 'src/components/Card/Card.vue';
import processRequestedFrontendActions from 'src/api/utils/processRequestedFrontendActions';
import isDevelopmentEnvironment from 'src/utils/developer/isDevEnvironment';
export default Vue.extend({
    components: { Card },
    data() {
        return {
            login: null,
            password: null,
            passwordConfirmation: null,
            showPasswordRecovery: false,
            email: null,
            bgImgObj: {
                urls: {
                    // full: 'https://images.unsplash.com/photo-1464925257126-6450e871c667?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2767&q=80'
                    // full: 'https://images.unsplash.com/photo-1489321336462-efe12c02d099?ixlib=rb-1.2.1&auto=format&fit=crop&w=668&q=80'
                    full: 'https://images.unsplash.com/photo-1582967788606-a171c1080cb0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2775&q=80'
                },
                user: {
                    name: 'Francesco Ungaro',
                    username: 'francesco_ungaro'
                },
                location: {
                    title: 'Red Sea',
                    name: 'Red Sea',
                    city: null,
                    country: null
                }
            },
            reloadImageButtonVisible: false
        };
    },
    computed: {
        unsplashLink() {
            const bgImgObj = this.bgImgObj;
            if (!bgImgObj)
                return '';
            if (!bgImgObj.user)
                return '';
            if (!bgImgObj.user.username)
                return '';
            return `https://unsplash.com/@${bgImgObj.user.username}`;
        },
        imageSource() {
            var _a, _b;
            return ((_b = (_a = this.bgImgObj) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.full) || '';
        },
        imageLocation() {
            const res = [];
            const loc = this.bgImgObj.location;
            const doPush = (x) => res.push(startCase(lowerCase(x || '')));
            if ((loc === null || loc === void 0 ? void 0 : loc.title) !== null)
                doPush(loc === null || loc === void 0 ? void 0 : loc.title);
            return res.join(', ');
        },
        imageAuthor() {
            var _a, _b;
            return startCase(lowerCase((_b = (_a = this.bgImgObj) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.name));
        },
        recoveryTitle() {
            if (this.resetToken)
                return 'Update password';
            return 'Password recovery';
        },
        passwordRecoveryHandler() {
            if (this.resetToken)
                return this.updatePassword;
            return this.resetPassword;
        },
        passwordRecoveryButtonTitle() {
            if (this.resetToken)
                return 'Update';
            return 'Reset password';
        },
        resetToken() {
            return this.$route.query['reset_token'];
        },
        oauthTokenObject() {
            const urlParamsString = location.search.substring(1);
            const params = new URLSearchParams(urlParamsString);
            return params;
        }
    },
    created() {
        return __awaiter(this, void 0, void 0, function* () {
            // show any message stored in localStorage.notice, then remove
            if (localStorage.notice) {
                const { message, type } = JSON.parse(localStorage.notice);
                if (message)
                    this.$q.notify({ message, type: (type || 'info') });
                localStorage.removeItem('notice');
            }
            if (this.oauthTokenObject.get('code')) {
                const code = this.oauthTokenObject.get('code');
                // hardcoded provider for now
                // probably will be fetched from the 'state' param from the URI
                const frontedAction = yield rpc('integrations.receive_oauth_callback', { code, provider: 'microsoft', redirect_uri: location.origin + location.pathname }, { public_action: true });
                processRequestedFrontendActions(frontedAction);
            }
            // show password recovery form if there is a reset token param
            if (this.resetToken)
                this.showPasswordRecovery = true;
            this.getRandomUnsplashPhoto();
        });
    },
    methods: {
        isDevelopmentEnvironment,
        submitCreds() {
            const creds = { auth: { login: this.login, password: this.password } };
            this.$store.dispatch('authorizedUser/submitCreds', { creds, ctx: this });
        },
        resetPassword() {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield rpc('users.reset_password', { email: this.email }, { public_action: true });
                if ((response === null || response === void 0 ? void 0 : response.result) === 'success') {
                    response.messages.forEach((message) => this.$q.notify({ message, type: 'info' }));
                }
            });
        },
        updatePassword() {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield rpc('users.users_password_update', { password: this.password, password_confirmation: this.passwordConfirmation, reset_token: this.resetToken }, { public_action: true });
                if ((response === null || response === void 0 ? void 0 : response.result) === 'success') {
                    response.messages.forEach((message) => this.$q.notify({ message, type: 'info' }));
                }
                this.password = null;
                this.passwordConfirmation = null;
            });
        },
        getRandomUnsplashPhoto() {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield rpc('utils.get_random_unsplash_photo', { collections: '994,353649' }, { public_action: true });
                if ((response === null || response === void 0 ? void 0 : response.result) !== 'Error') {
                    this.bgImgObj = response;
                    this.reloadImageButtonVisible = true;
                }
            });
        },
        oauthLogIn(provider) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                const urlData = yield rpc('integrations.generate_oauth_url', { provider }, { public_action: true });
                if (urlData && ((_a = urlData === null || urlData === void 0 ? void 0 : urlData.data) === null || _a === void 0 ? void 0 : _a.url)) {
                    window.location = urlData.data.url;
                }
            });
        }
    }
});
